module.exports = __webpack_public_path__ + "media/components/assets/icons/wheel-c2efe45ea64882535ed59f84702c994e.svg";